import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { CommonServiceService } from 'src/app/shared/common-service.service';
import { environment } from 'src/environments/environment';
import * as FileSaver from 'file-saver'
import { LoaderService } from 'src/app/shared/loader.service';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { AllowIn, ShortcutInput } from 'ng-keyboard-shortcuts';

@Component({
  selector: 'app-print-contra',
  templateUrl: './print-contra.component.html',
  styleUrls: ['./print-contra.component.scss']
})
export class PrintContraComponent implements OnInit {

  jvData: any;
  contraId: any;
  valid: boolean;
  shortcuts: ShortcutInput[] = [];
  @Input() reference_code;
  @Input() preFetchedData;
  @Output() callSaveFetchedData: EventEmitter<any> = new EventEmitter();

  constructor(
    public commonService: CommonServiceService,
	private spinner: NgxSpinnerService,
    private loaderService: LoaderService,
    public sanitizer: DomSanitizer,
    private route: ActivatedRoute,

  ) { 
    this.route.paramMap.subscribe(params => {
			this.contraId = params['params'].id
			if (this.contraId != undefined) {
				document.title = `Contra -  ${this.contraId}`
			}
		});
  }

  ngOnInit(): void {
	if(!this.preFetchedData){
		if(!this.contraId){
			this.contraId = this.reference_code
		}
		this.getJvData(this.contraId)
	}else{
		this.jvData = this.preFetchedData
		this.valid = true
	}
    
  }

  getJvData(searchId: any) {
		try {
			this.commonService.getRequest(`${environment.okountUrl}/contra/download?contra_code=${searchId}&preview=true`).subscribe(async (res) => {
        this.valid = true;
				this.jvData = this.transform(res)
			},
				err => {
					this.loaderService.hide()
				})
		} catch (error) {
			console.log('Error occured in gettting jv due to : ', error)
		}
	}
	transform(html) {
		return this.sanitizer.bypassSecurityTrustHtml(html);
	}

  downloadPdf(searchId: any) {
		this.commonService.downloadPDF(`${environment.okountUrl}/contra/download?contra_code=${searchId}&preview=false`, null).subscribe((fileBlob:any) =>{
			let fileName = `CONTA-${searchId}.pdf` 			
			let blob = new Blob([fileBlob], { 
				type: 'application/pdf'
			});
			FileSaver.saveAs(blob, fileName);
	   })
	} catch (error) {
		console.log('Error occured in download pdf due to : ', error)
	}
}
